import { Box, CssBaseline, Grid, ThemeProvider } from '@mui/material'
import { Outlet } from 'react-router-dom'
import { SnackbarProvider } from 'notistack'
import {
  Header,
  Path,
  ProfileContext,
  Settings,
  Sidebar,
} from '@kistill/client/shared/ui'

import { lightTheme, darkTheme } from '@kistill/client/shared/ui'
import { useContext } from 'react'
import { LayoutProvider } from '@kistill/client/shared/ui'

interface LayoutProps {
  listItems: Path[]
}

export function Layout({ listItems }: LayoutProps) {
  const { isDarkTheme } = useContext(ProfileContext)

  return (
    <ThemeProvider theme={isDarkTheme ? darkTheme : lightTheme}>
      <CssBaseline />
      <LayoutProvider>
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Header listItems={listItems} />
          <Box flexGrow={1} height={'calc(100vh - 3rem)'}>
            <Grid container wrap='nowrap'>
              <Grid item sx={{ display: { xs: 'none', md: 'flex' } }}>
                <Sidebar listItems={listItems} />
              </Grid>
              <Grid item flexGrow={1}>
                <Outlet />
              </Grid>
            </Grid>
          </Box>
          <Settings />
        </SnackbarProvider>
      </LayoutProvider>
    </ThemeProvider>
  )
}
